import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		mockForm_2_buildingAddress: {		
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.fontSize,
				padding: theme.spacing(0, 0, 1, 0),
				color: theme.palette.grey[400],
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
				padding: theme.spacing(2, 0),
				color: theme.palette.grey[500],
			},
		}
	});
}

export default styles;
